<template>
    <div class="content">
        <div class="container-fluid">
            <slot></slot>

        </div>
    </div>
</template>
